import * as actions from 'client/actions/entityActions'
import { useCallback } from 'react'

export default function useUpdateEntityStyle(dispatch, entity) {
  return useCallback(
    (style, sizing = null) =>
      value =>
        dispatch(
          actions.update({
            ...entity,
            styles: {
              ...entity.styles,
              [style]: sizing ? `${value}${sizing}` : value,
            },
          }),
        ),
    [entity],
  )
}
